module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-de-f6715aa5e2b90e8afd05a65d66e34834.svg";